/* TR MX · Visor de fotos para celular (ver snippets/trmx-lightbox.liquid) */
if (!customElements.get('trmx-lightbox')) {
  const mobile = window.matchMedia('(max-width: 749px)');

  customElements.define(
    'trmx-lightbox',
    class TrmxLightbox extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.trmx-lightbox__track');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.index = 0;

        this.querySelector('[data-close]').addEventListener('click', () => this.close());
        this.prevButton.addEventListener('click', () => this.go(this.index - 1));
        this.nextButton.addEventListener('click', () => this.go(this.index + 1));
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

        this.onOpenerClick = this.onOpenerClick.bind(this);
        this.onKeyUp = (event) => {
          if (event.key === 'Escape') this.close();
          if (event.key === 'ArrowLeft') this.go(this.index - 1);
          if (event.key === 'ArrowRight') this.go(this.index + 1);
        };
        this.onPopState = () => this.close(true);
        this.onViewportChange = () => {
          if (!mobile.matches) this.close();
        };

        // Se escucha en fase de captura para adelantarse al visor original del tema
        document.addEventListener('click', this.onOpenerClick, true);
        mobile.addEventListener('change', this.onViewportChange);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOpenerClick, true);
        mobile.removeEventListener('change', this.onViewportChange);
        this.close();
      }

      onOpenerClick(event) {
        if (!mobile.matches) return;
        const button = event.target.closest('.product__modal-opener--image .product__media-toggle');
        const gallery = document.getElementById(this.dataset.gallery);
        if (!button || !gallery || !gallery.contains(button)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(gallery, button.closest('modal-opener'));
      }

      open(gallery, opener) {
        const openers = Array.from(gallery.querySelectorAll('.product__media-list .product__modal-opener--image'));
        const start = Math.max(openers.indexOf(opener), 0);

        this.track.replaceChildren(
          ...openers.map((item, i) => {
            const source = item.querySelector('.product__media img');
            const slide = document.createElement('div');
            const image = document.createElement('img');
            slide.className = 'trmx-lightbox__slide';
            image.src = source.src;
            if (source.srcset) image.srcset = source.srcset;
            image.sizes = '100vw';
            image.alt = source.alt;
            if (Math.abs(i - start) > 1) image.loading = 'lazy';
            slide.append(image);
            return slide;
          })
        );

        this.openedBy = opener.querySelector('.product__media-toggle');
        this.hidden = false;
        document.body.classList.add('overflow-hidden');
        this.track.scrollLeft = start * this.track.clientWidth;
        this.setIndex(start);
        this.querySelector('[data-close]').focus();

        document.addEventListener('keyup', this.onKeyUp);
        // El botón "atrás" del celular cierra el visor en lugar de salir de la página
        history.pushState({ trmxLightbox: true }, '');
        window.addEventListener('popstate', this.onPopState);
      }

      close(fromHistory = false) {
        if (this.hidden) return;
        this.hidden = true;
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keyup', this.onKeyUp);
        window.removeEventListener('popstate', this.onPopState);
        if (!fromHistory && history.state && history.state.trmxLightbox) history.back();
        if (this.openedBy) this.openedBy.focus({ preventScroll: true });
      }

      go(index) {
        const target = Math.min(Math.max(index, 0), this.track.children.length - 1);
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
        this.setIndex(target);
      }

      onScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.setIndex(Math.round(this.track.scrollLeft / this.track.clientWidth));
        });
      }

      setIndex(index) {
        this.index = index;
        this.prevButton.disabled = index <= 0;
        this.nextButton.disabled = index >= this.track.children.length - 1;
      }
    }
  );
}
